export class LogPane {
  constructor(private el: HTMLElement) {}

  clear(): void {
    this.el.textContent = ''
  }

  info(message: string): void {
    this.append(message, 'info')
  }

  success(message: string): void {
    this.append(message, 'success')
  }

  error(message: string): void {
    this.append(message, 'error')
  }

  private append(message: string, kind: 'info' | 'success' | 'error'): void {
    const ts = new Date().toTimeString().slice(0, 8)
    const line = document.createElement('span')
    line.className =
      kind === 'error' ? 'log__line--error' :
      kind === 'success' ? 'log__line--success' : ''
    line.textContent = `[${ts}] ${message}\n`
    this.el.appendChild(line)
    this.el.scrollTop = this.el.scrollHeight
  }
}
